// 存放一些全局字典
export const shiftStatusMap = [
  {
    label: '坐班中(接收)',
    value: 0,
    status: 'success'
  },
  {
    label: '休息中',
    value: 1,
    status: 'error',
    hideDivider: true
  }
  // {
  //   label: '坐班中(拒收)',
  //   value: 2,
  //   status: 'success',
  //   hideDivider: true
  // }
]

// 聊天tabs key 和tab配置保持一致
export const chatGroupTabsKeyEnum = {
  导诊咨询: 'guideConsultGroupId',
  问诊会话: 'groupId',
  患者私聊: 'privateId',
  医生私聊: 'doctorDaGroupId',
  微信私聊患者: 'weComPatientChat'
}
export const patientRelationMap = ['本人', '父母', '', '爱人', '子女', '亲戚朋友', '其他']
